'use strict';

module.exports = {
  _usersUrl: 'pb/users/me',

  id: function(id) {
    this._id = id;
    return this;
  },

  baseUrl: function(baseUrl) {
    this._baseUrl = baseUrl;
    return this;
  },
};
